// Styles the Plan screens share (redesign slice 5b), from the design
// language: ruled rows, dashed "add" buttons, text actions, 44px targets.
import type { CSSProperties } from "react";
import { COLORS, FONT_SIZE, LAYOUT, RADIUS } from "../../lib/constants";

export const textButton: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  minHeight: LAYOUT.tapTarget,
  padding: 0,
  background: "transparent",
  border: "none",
  color: COLORS.accent,
  fontSize: FONT_SIZE.base,
  fontWeight: 700,
  textDecoration: "none",
  cursor: "pointer",
};

export const dashedButton: CSSProperties = {
  minHeight: LAYOUT.tapTarget,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: `1px dashed ${COLORS.accent}`,
  borderRadius: RADIUS.md,
  background: "transparent",
  color: COLORS.accent,
  fontSize: FONT_SIZE.sm,
  fontWeight: 700,
  cursor: "pointer",
  padding: "0 var(--space-xl)",
};

export const roundButton: CSSProperties = {
  width: LAYOUT.tapTarget,
  height: LAYOUT.tapTarget,
  borderRadius: RADIUS.pill,
  border: `1px solid ${COLORS.line}`,
  background: COLORS.card,
  color: COLORS.ink,
  fontSize: FONT_SIZE.h3,
  lineHeight: 1,
  padding: 0,
  cursor: "pointer",
  flexShrink: 0,
};

export const chip = (tone: "accent" | "caution" | "plain"): CSSProperties => ({
  minHeight: LAYOUT.tapTarget,
  display: "inline-flex",
  alignItems: "center",
  borderRadius: RADIUS.pill,
  padding: "0 var(--space-xl)",
  fontSize: FONT_SIZE.sm,
  fontWeight: 700,
  cursor: "pointer",
  border: `1px solid ${tone === "accent" ? COLORS.accent : tone === "caution" ? COLORS.caution : COLORS.line}`,
  background: tone === "accent" ? COLORS.accentTint : "transparent",
  color: tone === "accent" ? COLORS.accent : tone === "caution" ? COLORS.caution : COLORS.soft,
});

export const panel: CSSProperties = {
  border: `1px solid ${COLORS.line}`,
  borderRadius: RADIUS.xl,
  background: COLORS.card,
  padding: "var(--space-xl) var(--space-xxl)",
};

export const inputStyle: CSSProperties = {
  minHeight: LAYOUT.tapTarget,
  padding: "0 var(--space-lg)",
  borderRadius: RADIUS.md,
  border: `1px solid ${COLORS.line}`,
  background: COLORS.card,
  color: COLORS.ink,
  fontSize: FONT_SIZE.base,
  boxSizing: "border-box",
};
